module.exports = __webpack_public_path__ + "img/1.365fbf40.png";